var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "statistics" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _vm.title || _vm.description || _vm.parsedCta
          ? _c("div", { staticClass: "upper" }, [
              _vm.title
                ? _c("h2", { domProps: { innerHTML: _vm._s(_vm.title) } })
                : _vm._e(),
              _vm._v(" "),
              _vm.description
                ? _c("div", {
                    staticClass: "description",
                    domProps: { innerHTML: _vm._s(_vm.description) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.parsedCta
                ? _c(
                    "div",
                    { staticClass: "cta_container" },
                    [
                      _c("secondary-button", {
                        attrs: {
                          label: _vm.parsedCta.title,
                          link: _vm.parsedCta,
                          theme: "reverse",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.parsedStatistics, function (statistic, index) {
          return _c(
            "div",
            { key: index, staticClass: "statistic", class: _vm.statisticCount },
            [
              statistic.icon || statistic.statistic
                ? _c("div", { staticClass: "icon_statistic" }, [
                    statistic.icon_or_statistic === "icon" && statistic.icon
                      ? _c("img", {
                          attrs: {
                            src: statistic.icon.url,
                            alt: statistic.title,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    statistic.icon_or_statistic === "statistic" &&
                    statistic.statistic != ""
                      ? _c("h1", {
                          domProps: { innerHTML: _vm._s(statistic.statistic) },
                        })
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                statistic.title
                  ? _c("h4", {
                      domProps: { innerHTML: _vm._s(statistic.title) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                statistic.description
                  ? _c("div", {
                      staticClass: "description",
                      domProps: { innerHTML: _vm._s(statistic.description) },
                    })
                  : _vm._e(),
              ]),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }